module.exports = __webpack_public_path__ + "static/media/student-score-winbox.0276c135.png";